/**
=========================================================
* Material Dashboard 2 React - Projects Section
=========================================================

* Modernisé pour cohérence SaaS :
  - Cards arrondies
  - Grille fluide
  - Titres et typographie ajustés
*/

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images & data
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";

import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

function Projects() {
  return (
    <Card sx={{ padding: 3, borderRadius: 3 }}>
      <MDBox mb={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Projects
        </MDTypography>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <DefaultProjectCard
            image={logoXD}
            label="UI Design"
            title="Material XD Version"
            description="Add Material UI buttons, inputs, and navigation to screens"
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "view project",
            }}
            authors={[team1, team2, team3, team4]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DefaultProjectCard
            image={logoAtlassian}
            label="Development"
            title="Add Progress Track"
            description="Implement kanban board and progress tracking with API"
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "view project",
            }}
            authors={[team2, team3, team4]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DefaultProjectCard
            image={logoSlack}
            label="Communication"
            title="Fix Platform Errors"
            description="Resolve known bugs and deliver patch release"
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "view project",
            }}
            authors={[team1, team3]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DefaultProjectCard
            image={logoSpotify}
            label="Design"
            title="Launch New App"
            description="Prepare UI/UX, content and SEO for mobile app release"
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "view project",
            }}
            authors={[team4, team1]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DefaultProjectCard
            image={logoJira}
            label="Planning"
            title="Create Tasks for Team"
            description="Structure sprint goals and assign responsibilities"
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "view project",
            }}
            authors={[team3, team2]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DefaultProjectCard
            image={logoInvesion}
            label="Documentation"
            title="Redesign Landing Page"
            description="Integrate feedback and refresh public landing page"
            action={{
              type: "internal",
              route: "/",
              color: "info",
              label: "view project",
            }}
            authors={[team1, team4]}
          />
        </Grid>
      </Grid>
    </Card>
  );
}

export default Projects;
